import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import 'core-js'
import DateFilter from './DateFilter.js'

ReactDOM.render(<CookiesProvider><App /></CookiesProvider>, document.getElementById('root'));
//ReactDOM.render(<DateFilter/>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js